import { render, staticRenderFns } from "./TermDefinition.vue?vue&type=template&id=54c2a3ca&"
import script from "./TermDefinition.vue?vue&type=script&lang=js&"
export * from "./TermDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports